import { LoadingOutlined, MailOutlined, MenuFoldOutlined, PlusOutlined, UnlockOutlined } from "@ant-design/icons";
import { Pagination } from "antd";
import { Helmet } from "react-helmet-async";
import { Link, useSearchParams } from "react-router-dom";
import Sidebar from "../../../components/Sidebar/Sidebar";
import { useState } from "react";
import { useMainContext } from "../../../components/Context/MainContext";


function ForYouPage() {
    const {setSidebarCollapsed} = useMainContext();
    const [companyCount,setCompanyCount] = useState(null);
    const [loading,setLoading] = useState(false);
    const [page,setPage] = useState(0);

    return(
        <div className="bg-black min-h-screen">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{`VC Hunt - Find a Company`}</title>
                <meta property="og:title" content={`VC Hunt - Find a Company`}/>
                <meta name="description" content={`VC Hunt - Find a Company`} />
                <link rel="canonical" href="https://www.vc-hunt.com" />
            </Helmet>
            <div className="text-left">
                <div className="grid grid-cols-1 md:grid-cols-4 lg:grid-cols-5 gap-4 w-full m-auto">
                    <div className="pl-8 py-8 static md:sticky top-0 h-screen">
                        <div className="flex flex-col text-white w-full md:w-11/12 h-full m-auto">
                            <div className="fixed top-0 left-0 right-0 bg-black h-20 p-4 shadow-lg flex items-center z-20 md:relative mb-4 mb-8 flex items-center">
                                <div className="flex-1">
                                    <Link to='/'>
                                        <h1>VC Hunt</h1>
                                    </Link>
                                </div>
                                <div className="block md:hidden text-2xl">
                                    <div className="rounded-xl bg-[#1B191C] px-3 aspect-square flex items-center justify-center" onClick={() => setSidebarCollapsed(true)}>
                                        <MenuFoldOutlined/>
                                    </div>
                                </div>
                            </div>
                            <div className="hidden md:block h-full">
                                <Sidebar />
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 md:col-span-3 lg:col-span-4 flex grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 p-2 md:p-0 bg-black">
                        <div className="col-span-1 md:col-span-3 flex flex-col items-start h-full text-white w-full md:w-10/12 lg:w-11/12 m-auto pb-0 lg:pb-12">
                            <div className="h-20 md:h-28 flex items-center mb-8 md:mb-0 bg-black relative md:sticky top-0 z-10 shadow-lg w-full h-auto">
                                <div className="pt-0 md:pt-4 pl-2 md:pl-0">
                                    <h1 className="leading-none mb-0.5 text-5xl md:text-4xl">
                                        Raising Money?
                                    </h1>
                                    {
                                        companyCount &&
                                            <div>
                                                <h4 className="m-auto font-medium">{companyCount} Results</h4>
                                            </div>
                                    }
                                </div>
                            </div>
                            <div className="flex flex-col gap-4 w-full md:w-11/12 mb-4">
                                {
                                    loading &&
                                        <div className="text-center text-xl">
                                            <LoadingOutlined />
                                        </div>
                                }
                                <div className="p-10 rounded-2xl bg-[#1B191C] text-white w-full flex flex-col gap-4">
                                    <div>
                                        <h2 className="m-0 leading-tight">Get a Personalized List of Investors/Funds.</h2>
                                    </div>
                                    <div className="mb-4">
                                        <div className="m-0 leading-tight text-xl">
                                            <p className="mb-6">
                                                <strong>I'm building a recommendation system</strong> matching startups with investors.
                                            </p>
                                            <div className="mb-4">
                                                <p className="mb-1">
                                                    The model will look at:
                                                </p>
                                                <ul className="list-disc pl-4 text-lg leading-tight">
                                                    <li>Industry</li>
                                                    <li>Stage</li>
                                                    <li>Investor Thesis</li>
                                                    <li>Founding/Investing Teams</li>
                                                    <li>Personality/Fit*</li>
                                                    <li>other.</li>
                                                </ul>
                                            </div>
                                            <div className="mb-4">
                                                Just email me with some information about your startup and I will send you our recommendation list.
                                            </div>
                                            <p className="font-semibold">
                                                Free until the model goes live on the website.
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <a href='mailto:me@daikiminaki.com' target="_blank">
                                            <div className="border w-full md:w-1/2 p-2 text-center text-base rounded-md hover:font-semibold cursor-pointer">
                                                <MailOutlined/> Get Your List
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForYouPage;